import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClaimRakurakuHistory } from "../../entity/EntityClaimRakurakuHistory";

export class DtoClaimRakurakuHistorysGetReq extends EntityClaimRakurakuHistory {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_claim_rakuraku_history_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
